import {Action} from 'redux'
import {BankDetailModel} from '../Model/BankDetailModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialBankDetailState: IBankDetailState = {
  data: {
    aboutBank: [],
    meta: [],
  },
  sortBankDetailData: [],
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IBankDetailState {
  data?: {
    aboutBank?: BankDetailModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortBankDetailData?: IBankDetailState[]
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IBankDetailState = initialBankDetailState,
  action: ActionWithPayload<IBankDetailState>
) => {
  switch (action.type) {
    //GET BankDetail DATA
    case actionTypes.GET_BANK_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_BANK_DETAIL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_BANK_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add BankDetail
    case actionTypes.ADD_BANK_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_BANK_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_BANK_DETAIL: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update BankDetail
    case actionTypes.UPDATE_BANK_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_BANK_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_BANK_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_BANK_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_BANK_DETAIL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_BANK_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_BANK_DETAIL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_BANK_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_BANK_DETAIL_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_BANK_DETAIL_SUCCESS: {
      const changedData: any = action.payload?.data?.aboutBank
      let newData = state?.data?.aboutBank?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, aboutBank: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_BANK_DETAIL_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_BANK_DETAIL_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_BANK_DETAIL_SUCCESS: {
      const changedData: any = action.payload?.data?.aboutBank
      let newData = state?.data?.aboutBank?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, aboutBank: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_BANK_DETAIL_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_BANK_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_BANK_DETAIL_SUCCESS: {
      return {
        ...state,
        sortBankDetailData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_BANK_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_BANK_DETAIL_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortBankDetailData: [],
      }
    }

    default:
      return state
  }
}
